import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.188 11.333h2.666A3.333 3.333 0 0 0 12.188 8v-.667h.666a2 2 0 0 0 0-4h-.666v-.666A.667.667 0 0 0 11.52 2h-8a.667.667 0 0 0-.667.667V8a3.333 3.333 0 0 0 3.334 3.333m6-6.666h.666a.667.667 0 1 1 0 1.333h-.666zm-8-1.334h6.666V8a2 2 0 0 1-2 2H6.188a2 2 0 0 1-2-2zm10 9.334h-12a.667.667 0 1 0 0 1.333h12a.666.666 0 1 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })